import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { CONFIG } from '../graphql/queries/config';
/**
 * Custom hook for fetching config
 *
 * @returns {Object} - An object containing the application configuration.
 */
export const useConfig = () => {
    const { data } = useQuery(CONFIG);
    const config = useMemo(() => {
        return data?.config;
    }, [data]);
    return config;
};
